import useIndustryProfile from "../../../hooks/useIndustryProfile";
import useIndustryApprovalStatus from "../../../hooks/useIndustryApprovalStatus";
import useIndustryPaymentStatus from "../../../hooks/useIndustryPaymentStatus";
import IndustryDashboardLayout from "./dashboard/IndustryDashboardLayout";
const IndustryLayout = () => {
    const profileExists = useIndustryProfile();
    const isIndustryApproved= useIndustryApprovalStatus(profileExists);
     useIndustryPaymentStatus(isIndustryApproved)
  return (
      <IndustryDashboardLayout/>
  );
};

export default IndustryLayout;
